module.exports = __webpack_public_path__ + "img/648-11d14f.png";